/**
 * * Удалить префик у base64
 * @param base64String
 * @returns
 */
export const removeBase64Prefix = (base64String: string): string => {
  // Найдем индекс первого вхождения "base64,"
  const base64PrefixIndex = base64String.indexOf("base64,");

  // Если префикс найден, обрезаем строку после него
  if (base64PrefixIndex !== -1) {
    return base64String.slice(base64PrefixIndex + "base64,".length);
  }

  // Если префикс не найден, возвращаем строку без изменений
  return base64String;
};
